import {useContext} from 'react';
import RouteConfigsContext from 'src/public/Router/RouteConfigsContext';

import type {RouteConfigs} from 'src/types';

export default function useRouteConfigs(): RouteConfigs {
  return useContext(RouteConfigsContext);
}
